import type { IconProps } from '../types/IconProps.ts';
export const Columns2: IconProps = {
    name: 'Columns2',
    children: [
        `<rect width="18" height="18" x="3" y="3" rx="2" />`,
        `<path d="M12 3v18" />`,
    ]
};